/**
 * WidgetDemo - Demo page showing the floating widget
 */
import React from 'react';
import WidgetPopup from './WidgetPopup';

const WidgetDemo = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      {/* Simulated website content */}
      <div className="max-w-4xl mx-auto py-12 px-4">
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            StrongFit - Personal Training & EMS
          </h1>
          <p className="text-gray-600 mb-6">
            Dies ist eine Demo-Seite, die zeigt, wie das Chat-Widget auf Ihrer Website aussehen würde.
            Das goldene runde Symbol unten rechts ist das Contact-Widget.
          </p>
          
          <div className="space-y-4">
            <div className="bg-gray-50 p-4 rounded-lg">
              <h2 className="font-semibold text-gray-800 mb-2">Widget-Funktionen:</h2>
              <ul className="list-disc list-inside text-gray-600 space-y-1">
                <li><strong>Live Chat</strong> - KI-gestützter Chat für Fragen</li>
                <li><strong>WhatsApp</strong> - Direkter Link zu WhatsApp</li>
                <li><strong>Instagram</strong> - Link zum Instagram-Profil</li>
                <li><strong>Facebook</strong> - Link zur Facebook-Seite</li>
              </ul>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg">
              <h3 className="font-semibold text-yellow-800 mb-2">📋 Einbettungscode</h3>
              <p className="text-sm text-yellow-700 mb-2">
                Fügen Sie diesen Code vor dem &lt;/body&gt; Tag Ihrer Website ein:
              </p>
              <pre className="bg-gray-900 text-green-400 p-3 rounded text-xs overflow-x-auto">
{`<script>
(function() {
  var iframe = document.createElement('iframe');
  iframe.src = '${window.location.origin}/widget/popup';
  iframe.style.cssText = 'position:fixed;bottom:0;right:0;width:450px;height:650px;border:none;z-index:9999;background:transparent;pointer-events:none;';
  iframe.setAttribute('allowtransparency', 'true');
  iframe.onload = function() {
    iframe.style.pointerEvents = 'auto';
  };
  document.body.appendChild(iframe);
})();
</script>`}
              </pre>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <h2 className="text-xl font-bold text-gray-900 mb-4">Beispiel-Inhalt</h2>
          <p className="text-gray-600 mb-4">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor 
            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud 
            exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </p>
          <p className="text-gray-600">
            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu 
            fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in 
            culpa qui officia deserunt mollit anim id est laborum.
          </p>
        </div>
      </div>

      {/* The floating widget */}
      <WidgetPopup />
    </div>
  );
};

export default WidgetDemo;
